import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../patterns';

interface Props {
  show: boolean;
  userName: string;
  tempPassword: string;
  onHide: () => void;
}

const UserCreatedModal: React.FC<Props> = ({ show, userName, tempPassword, onHide }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(tempPassword);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Modal show={show} onHide={onHide} title={t('system.users.createdTitle')} size="md">
      <Modal.Body>
        <p>{t('system.users.createdBody', { name: userName })}</p>
        <div className="pat-field">
          <label className="pat-field__label">{t('system.users.resetPassword.tempPasswordLabel')}</label>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <code
              data-testid="temp-password"
              style={{
                fontFamily: 'monospace',
                fontSize: 18,
                padding: '8px 12px',
                border: '1px solid var(--shell-border)',
                borderRadius: 6,
              }}
            >
              {tempPassword}
            </code>
            <button type="button" className="pat-btn pat-btn--subtle" onClick={handleCopy}>
              {copied
                ? t('system.users.resetPassword.copied')
                : t('system.users.resetPassword.copyButton')}
            </button>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="pat-btn pat-btn--primary" onClick={onHide}>
          {t('system.users.resetPassword.doneAction')}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserCreatedModal;
